import request from "@/utils/request";

export function publishJob(data) {
  return request({
    url:'/job/publish',
    method: 'post',
    data
  })
}

export function updateJob(data) {
  return request({
    url:'/job/updateJob',
    method: 'post',
    data
  })
}

export function getJobDetail(id, online, view) {
  return request({
    url: '/job/jobDetail',
    method: 'get',
    params:{jobId:id, online: online, view: view}
  })
}

export function getJobModifyDetail(id, online, isPreview) {
  return request({
    url: '/job/modify/detail',
    method: 'get',
    params:{jobId:id, online:online, isPreview: isPreview}
  })
}


export function getJobLists(data) {
  return request({
    url: '/job/jobList',
    method: 'post',
    data
  })
}

export function upOrDelJob(data) {
  return request({
    url: '/job/upOrDel',
    method: 'post',
    data
  })
}

export function getJobEnum() {
  return request({
    url: '/job/getJobEnum',
    method: 'get'
  })
}

export function getJobViewLists(data) {
  return request({
    url: '/job/view/list',
    method: 'post',
    data
  })
}

export function getRecommendJobList(data) {
  return request({
    url: '/job/recommend/list',
    method: 'post',
    data
  })
}

export function getEnterpriseApplyLists(data) {
  return request({
    url: '/job/apply/enterprise/list',
    method: 'post',
    data
  })
}

export function getEnterpriseApplyLists2(data) {
  return request({
    url: '/job/apply/enterprise/list2',
    method: 'post',
    data
  })
}


export function addApplyProgress(data) {
  return request({
    url: '/job/apply/add/progress',
    method: 'post',
    data
  })
}

export function applyJobIng(data) {
  return request({
    url: '/job/apply/job/ing',
    method: 'post',
    data
  })
}

export function applyNewJob(data) {
  return request({
    url: '/job/apply/new/job',
    method: 'post',
    data
  })
}

export function applyDownloadJob(data) {
  return request({
    url: '/job/apply/download/job',
    method: 'post',
    data
  })
}

export function getMyApplyList(data) {
  return request({
    url: '/job/apply/my/list',
    method: 'post',
    data
  })
}

export function getMyApplyList2(data) {
  return request({
    url: '/job/apply/my/list2',
    method: 'post',
    data
  })
}

export function getSimpleCvList() {
  return request({
    url: '/job/cv/getSimpleCvList',
    method: 'get'
  })
}

export function addComments(data) {
  return request({
    url: '/job/apply/add/comment',
    method: 'post',
    data
  })
}

export function  getEntApplyTotal(jobId) {
  return request({
    url: '/job/apply/enterprise/total',
    method: 'get',
    params:{jobId:jobId}
  })
}

export function queryJobComments(data) {
  return request({
    url: '/job/query/jobComments',
    method: 'post',
    data
  })
}

export function refreshJob(id) {
  return request({
    url: '/job/modify/refresh',
    method: 'get',
    params:{jobId:id}
  })
}

export function addInterview(data) {
  return request({
    url: '/job/apply/add/interview',
    method: 'post',
    data
  })
}

export function queryInterview(data) {
  return request({
    url: '/job/apply/interview/list',
    method: 'post',
    data,
    headers: {
      "hideLoading": true
    }
  })
}

export function changeInterview(data) {
  return request({
    url: '/job/apply/interview/change',
    method: 'post',
    data
  })
}

export function addInterviewByJob(data) {
  return request({
    url: '/job/apply/add/interview/byJob',
    method: 'post',
    data
  })
}

export function getPublishJob() {
  return request({
    url: '/job/query/publish/job',
    method: 'get'
  })
}

export function getTopPublishJob(id) {
  return request({
    url: '/job/query/top/publish/job',
    method: 'get',
    params:{enterpriseId:id}
  })
}

export function interviewRequire(data) {
  return request({
    url: '/job/apply/interview/require',
    method: 'post',
    data
  })
}

export function getJobStatistics() {
  return request({
    url: '/job/query/jobStatistics',
    method: 'get'
  })
}

export function jobAbilityConsume(data) {
  return request({
    url: '/job/jobAbilityConsume',
    method: 'post',
    data
  })
}

export function getCvInbox(data) {
  return request({
    url: '/job/apply/cv/inbox',
    method: 'post',
    data
  })
}

export function getCommentCount(limit) {
  return request({
    url: '/job/apply/query/comment/count',
    method: 'get',
    params:{limit:limit}
  })
}

export function getApplyJobInfoByCvId(cvId) {
  return request({
    url: '/job/apply/cv/getApplyJobInfoByCvId',
    method: 'get',
    params:{cvId:cvId}
  })
}

export function getCvSourceByCvId(cvId) {
  return request({
    url: '/job/apply/cv/getCvSourceByCvId',
    method: 'get',
    params:{cvId:cvId}
  })
}

export function queryRecruitData(jobId, dataModel) {
  return request({
    url: '/job/apply/queryRecruitData',
    method: 'get',
    params:{jobId:jobId, dataModel:dataModel}
  })
}

export function queryRecruitPower(jobId, dataRange) {
  return request({
    url: '/job/queryRecruitPower',
    method: 'get',
    params:{jobId:jobId, dataRange:dataRange}
  })
}

export function queryCvRecruitPower(jobId, dataRange) {
  return request({
    url: '/job/queryCvRecruitPower',
    method: 'get',
    params:{jobId:jobId, dataRange:dataRange}
  })
}

export function queryRecruitPowerUser(jobType, cvId, dataRange) {
  return request({
    url: '/job/queryRecruitPower/user',
    method: 'get',
    params:{jobType:jobType,cvId:cvId, dataRange:dataRange}
  })
}

export function queryCvRecruitPowerUser(jobType, cvId , dataRange) {
  return request({
    url: '/job/queryCvRecruitPower/user',
    method: 'get',
    params:{jobType:jobType,cvId:cvId, dataRange:dataRange}
  })
}

export function getJobCache(key, def) {
  return request({
    url: '/job/comm/getCache',
    method: 'get',
    params:{key:key, def: def}
  })
}

export function entCommentLabels(entId) {
  return request({
    url: '/job/apply/ent/comment/labels',
    method: 'get',
    params:{entId:entId}
  })
}


export function getUserLabelList(userId) {
  return request({
    url: '/job/apply/user/comment/labels',
    method: 'get',
    params:{userId:userId}
  })
}



// WEBPACK FOOTER //
// ./src/api/job.js